import {
  createContext,
  createSignal,
  onCleanup,
  onMount,
  ParentComponent,
} from "solid-js";

import { useAuth } from "../auth/AuthContext.js";
import { CommandBar } from "./CommandBar.js";

const CommandBarContext = createContext();

export const CommandBarProvider: ParentComponent = (props) => {
  const auth = useAuth();
  const [showCommandBar, setShowCommandBar] = createSignal(false);

  const handleKeyPress = (e: KeyboardEvent) => {
    if (!auth?.authenticatedUser()) {
      return;
    }
    if (e.metaKey && e.key === "k") {
      e.preventDefault();
      setShowCommandBar(true);
    }
  };

  onMount(() => {
    document.addEventListener("keydown", handleKeyPress);
  });

  onCleanup(() => {
    document.removeEventListener("keydown", handleKeyPress);
  });

  return (
    <CommandBarContext.Provider value={props}>
      <CommandBar
        show={showCommandBar()}
        onClose={() => setShowCommandBar(false)}
      />
      {props.children}
    </CommandBarContext.Provider>
  );
};
